import type { RfqViewState } from "./rfq-view-types";
import { rfqMoneyLabel, rfqDaysLabel } from "./rfq-presentation";
import { can } from "../../../../shared/auth/access";

type Props = Pick<RfqViewState,
  | "user"
  | "offers"
  | "contractCompliance"
  | "governanceBusy"
  | "evaluateContract"
  | "createContractOrder"
>;

export function RfqOfferList({
  user, offers, contractCompliance, governanceBusy, evaluateContract, createContractOrder,
}: Props) {
  return (
    <div className="rfq-offer-visibility-list">
      {(offers?.offers ?? []).map((offer) => {
        const offerVersionId = offer.id;
        const compliance = offerVersionId
          ? contractCompliance.find((item) => item.offerVersionId === offerVersionId)
          : undefined;
        return <article key={`${offer.supplierId}-${offer.version}`} className="rfq-offer-governance-card">
          <div>
            <strong>{offer.supplierName}</strong>
            <span>
              Sürüm {offer.version} · {new Date(offer.submittedAt).toLocaleString("tr-TR")}
            </span>
          </div>
          {offers?.unsealed ? (
            <dl>
              <div>
                <dt>Sunucu toplamı</dt>
                <dd>
                  {rfqMoneyLabel(offer.grandTotal, offer.currency)}
                </dd>
              </div>
              <div>
                <dt>Ödeme vadesi</dt>
                <dd>{rfqDaysLabel(offer.paymentTermDays)}</dd>
              </div>
              <div>
                <dt>Teslimat</dt>
                <dd>{rfqDaysLabel(offer.deliveryLeadDays)}</dd>
              </div>
            </dl>
          ) : (
            <span className="rfq-sealed-badge">İçerik kapalı</span>
          )}
          {offers?.unsealed && offerVersionId ? <div className="contract-compliance-inline">
            <div className="contract-compliance-inline-heading">
              <div>
                <span className="section-kicker">SÖZLEŞME KONTROLÜ</span>
                <strong>
                  {compliance
                    ? compliance.result === "FULLY_COMPLIANT"
                      ? "Tam Uyumlu"
                      : compliance.result === "COMPLIANT_WITH_WARNINGS"
                        ? "Uyarılı Uyumlu"
                        : "Sözleşme Dışı"
                    : "Henüz değerlendirilmedi"}
                </strong>
              </div>
              <div className="contract-compliance-actions">
                <button
                  type="button"
                  className="secondary-button"
                  disabled={governanceBusy || !can(user, "contract.compliance.evaluate")}
                  title={can(user, "contract.compliance.evaluate") ? undefined : "Sözleşme değerlendirme yetkiniz bulunmuyor."}
                  onClick={() => void evaluateContract(offerVersionId)}
                >
                  {compliance ? "Yeniden değerlendir" : "Sözleşmeyi kontrol et"}
                </button>
                {compliance?.result === "FULLY_COMPLIANT" && can(user, "contract.order.authorize") ? <button
                  type="button"
                  className="primary-button"
                  disabled={governanceBusy}
                  onClick={() => void createContractOrder(offerVersionId)}
                >Sipariş rotasını değerlendir</button> : null}
              </div>
            </div>
            {compliance ? <details>
              <summary>
                {compliance.checks.filter((item) => item.status !== "PASS").length
                  ? `${compliance.checks.filter((item) => item.status !== "PASS").length} dikkat noktası`
                  : `${compliance.checks.length} kontrolün tamamı geçti`}
              </summary>
              <div className="contract-compliance-checks">
                {compliance.checks.map((item) => <div key={item.field} className={item.status.toLowerCase()}>
                  <span>{item.status === "PASS" ? "Geçti" : item.status === "WARNING" ? "Uyarı" : "Uyumsuz"}</span>
                  <div>
                    <strong>{item.label}</strong>
                    <p>{item.reason}</p>
                    <small>Teklif: {item.actual} · Sözleşme: {item.contract} · Fark: {item.difference || "Yok"}</small>
                  </div>
                </div>)}
              </div>
            </details> : <p>Aktif sözleşme, ticari koşullar, kalite ve belge kanıtları sunucuda birlikte denetlenir.</p>}
          </div> : null}
        </article>;
      })}
      {offers && !offers.offers.length ? (
        <p>Henüz gönderilmiş teklif bulunmuyor.</p>
      ) : null}
    </div>
  );
}
